/**
 * This is a temporary type extension to introduce the `ScaledDown` enum value to the `ResourceStatus` enum.
 * On the backend we still treat the `ScaledDown` status as `READY` status.
 *
 * TODO:
 * Extend the backend functionality to introduce a `ScaledDown` status, and still handle all other resource
 * removal (i.e. DNS, Service Account, Database, Vault Secrets, etc.) when the service is in the `ScaledDown` status and get rid
 * of this temporary type extension and update the `codegen.yml` accordingly.
 */
export enum ResourceStatus {
  /** Error Creating */
  CreateError = 'CREATE_ERROR',
  /** Pending Create */
  CreatePending = 'CREATE_PENDING',
  /** Delete Completed */
  DeleteCompleted = 'DELETE_COMPLETED',
  /** Error Deleting */
  DeleteError = 'DELETE_ERROR',
  /** Pending Delete */
  DeletePending = 'DELETE_PENDING',
  /** Ready */
  Ready = 'READY',
  /** Scaled Down */
  ScaledDown = 'SCALED_DOWN',
}
